
export const interval = (func, time) => {
  const result = func();
  if (result) return;
  setTimeout(() => {
    interval(func, time);
  }, time);
};

export const formatDate = (date, format) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const month2 = month < 10 ? `0${month}` : month;
  const day = date.getDate();
  const day2 = day < 10 ? `0${day}` : day;
  const hour = date.getHours();
  const hour2 = hour < 10 ? `0${hour}` : hour;
  const minute = date.getMinutes();
  const minute2 = minute < 10 ? `0${minute}` : minute;
  const second = date.getSeconds();
  const second2 = second < 10 ? `0${second}` : second;
  return format.replace('YYYY', year.toString())
    .replace('MM', month2.toString())
    .replace('M', month.toString())
    .replace('DD', day2.toString())
    .replace('D', day.toString())
    .replace('hh', hour2.toString())
    .replace('h', hour.toString())
    .replace('mm', minute2.toString())
    .replace('m', minute.toString())
    .replace('ss', second2.toString())
    .replace('s', second.toString());
};


export const throttle = (func) => {
  let running = false;
  return () => {
    if (running) return;
    running = true;
    requestAnimationFrame(() => {
      func();
      running = false;
    });
  };
};

export const getQuery = () => {
  const querystr = window.location.href.split('?')[1];
  if (querystr) {
    const kv = querystr.split('#')[0].split('&');
    const res = {};
    Object.values(kv).forEach((item) => {
      const [k, v] = item.split('=');
      res[k] = v;
    });

    return res;
  }

  return {};
};

// base64 转换为 blob
export const base64ToBlob = (code) => {
  const parts = code.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

// 通过文件url 下载
export const downLoadFileByUrl = (url, filename) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.download = filename;
  a.click();
};

// 二进制流直接下载
export const downloadFileByBolb = (stream, filename) => {
  downLoadFileByUrl(URL.createObjectURL(stream), filename);
};

// base64 下载
export const downloadFileByBase64 = (base64, filename) => {
  const stream = base64ToBlob(base64);
  downloadFileByBolb(stream, filename);
};

// 指定的跳转页面
export const landingPage = {
  Home: '/userCenter',
  ShowWindowManage: '/manage',
  PickGoods: 'selectedGoods/unknown/0',
  Order: '/statistic/order', // 还没有订单管理页，跳转到首页
};

// 传入 type 参数的优先级最高，没有获取到媒体方进入 query 的 page，则采用参数的路径，首页路径作为兜底
export const getLandingPage = (config) => {
  const { type, mediaType, defaultPage } = config || {};
  const userCenter = '/userCenter';
  if (type === 'ShowWindowManage') {
    // 前往橱窗管理页面的媒体类型的拼接
    return `${landingPage[type]}/${mediaType}`;
  }
  return landingPage[type] || defaultPage || userCenter;
};

const storage = function (type) {
  let storage;
  if (type === 'local') {
    storage = window.localStorage;
  }
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  return {
    getItem(name) {
      let value = storage.getItem(name);
      try {
        value = JSON.parse(value);
      } catch (err) { }
      return value;
    },
    setItem(name, value) {
      let setRes = value;
      let oldValue = storage.getItem(name);
      try {
        oldValue = JSON.parse(oldValue);
      } catch (err) {
        oldValue = {};
      }
      if (!name) {
        return;
      }
      if (typeof value === 'object') {
        setRes = JSON.stringify({ ...oldValue, ...value });
      }
      storage.setItem(name, setRes);
    },
  };
};

export const localStorage = storage('local');

export const sessionStorage = storage('session');
